import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  DOMAIN_POOL_LIST,
  DOMAIN_POOL_ADD,
  DOMAIN_POOL_UPDATE,
  M_GET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { IDomainPoolAdd, IDomainPoolUpdate } from '@/interface/DomainPool';

@Module({ name: 'domain-pool' })
export default class DomainPool extends VuexModule {
  @Action
  async FetchDomainList() {
    console.log('Fetch Domain List');
    return Vue.axios({
      url: BASE_URL + DOMAIN_POOL_LIST,
      method: M_GET,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  async AddDomainList(params: IDomainPoolAdd) {
    return Vue.axios({
      url: BASE_URL + DOMAIN_POOL_ADD,
      method: M_POST,
      data: params,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  async UpdateDomainList(params: IDomainPoolUpdate) {
    return Vue.axios({
      url: BASE_URL + DOMAIN_POOL_UPDATE,
      method: M_POST,
      data: params,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
